export default function MySQL_ATAN() {
  return (
    <div>
      <h2>MySQL_ATAN</h2>    </div>
  );
}